import React from "react";
import { Hero, StatsBar, WhyUs, ServicesPreview, CTABanner, TestimonialsPreview, ProcessDiagram } from "../components/Sections";
import { SuccessStories, WhatDrivesUs } from "../components/NewSections";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowRight } from "lucide-react";

const Home = () => (
  <main>
    <Hero />
    <StatsBar />

    {/* About teaser */}
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4 grid lg:grid-cols-2 gap-12 items-center">
        <div className="relative">
          <div className="absolute -inset-4 bg-knight-gold/20 rounded-3xl rotate-3" />
          <img
            src="https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?crop=entropy&cs=srgb&fm=jpg&w=900&q=80"
            alt="Knight Credit Consultations"
            className="relative rounded-3xl shadow-2xl w-full h-[480px] object-cover"
          />
          <div className="absolute -bottom-6 left-6 bg-white rounded-2xl shadow-xl p-5 max-w-[220px]">
            <div className="font-display text-3xl font-bold text-knight-navy">15+</div>
            <p className="text-xs text-knight-navy/60 font-medium">Years combined experience in credit consulting</p>
          </div>
        </div>
        <div>
          <p className="text-knight-gold font-semibold tracking-widest text-xs mb-3">ABOUT US</p>
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-knight-navy mb-5">Rebuild, Repair & Improve <em>Your Credit Score</em></h2>
          <p className="text-knight-navy/75 leading-relaxed mb-4">
            Welcome to Knight Credit Consultants, where we empower individuals to take control of their financial future through expert credit solutions. With a commitment to honesty and integrity, our team specializes in personalized credit repair, education, and monitoring services designed to help you build and maintain a strong credit profile.
          </p>
          <p className="text-knight-navy/75 leading-relaxed mb-6">
            We believe that everyone deserves a second chance at financial stability. Let us guide you on the path to a brighter financial future with our proven strategies and dedicated support.
          </p>
          <Link to="/about">
            <Button className="bg-knight-navy hover:bg-knight-navy-dark text-white btn-lift">
              Learn More <ArrowRight size={16} className="ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>

    <WhyUs />
    <WhatDrivesUs />
    <ServicesPreview />
    <ProcessDiagram />
    <SuccessStories />
    <CTABanner title="Ready to start your credit repair journey?" subtitle="Learn how our service works by scheduling your free consultation." />
    <TestimonialsPreview />
    <CTABanner />
  </main>
);

export default Home;
